import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    PageSection,
    SectionTitle,
} from 'wanderu-components';

import localize from 'wanderu-i18n/src/localize';

import styles from './Quickview.scss';

function Metric(props) {
    const {
        i18nMoney,
        i18nNumber,
        t,
        name,
        type,
        value,
        totalMetrics,
    } = props;

    function getMetricValue(value, type) {
        switch (type) {
            case 'currency':
                return i18nMoney(value).format();
            case 'duration':
                return t('baseApp:trip-duration_hours', {
                    hours: Math.floor(value / 60),
                    minutes: value % 60,
                });
            case 'number':
                return i18nNumber(value).format();
            default:
                return value;
        }
    }

    const flexBasisPercentage = 100 * (1 / totalMetrics);

    return (
        <tr className={styles.metric} style={{ flexBasis: `${flexBasisPercentage}%` }}>
            <td className={styles.metricName}>
                {name}
            </td>
            <td className={styles.metricValue}>
                {getMetricValue(value, type)}
            </td>
        </tr>
    );
}

const MetricComponent = localize(Metric);

function Quickview(props) {
    const {
        children,
        className,
        layoutClassName,
        metrics,
        subtitle,
        title,
        titleClassName,
    } = props;

    return (
        <PageSection
            aria-labelledby="quickview-title"
            className={`${className} ${styles.quickview}`}
            layoutClassName={classNames(layoutClassName, styles.quickviewLayout)}
        >
            <SectionTitle
                className={`${styles.sectionTitle} ${titleClassName}`}
                id="quickview-title"
            >
                {title}
            </SectionTitle>

            <h3 className={styles.subtitle}>
                {subtitle}
            </h3>

            <table className={styles.metricsTable}>
                <tbody className={styles.metrics}>
                    {metrics.map((metric) => (
                        <MetricComponent
                            key={metric.name}
                            totalMetrics={metrics.length}
                            {...metric}
                        />
                    ))}
                </tbody>
            </table>
            {children}
        </PageSection>
    );
}

Quickview.propTypes = {
    className: PropTypes.string,
    layoutClassName: PropTypes.string,
    metrics: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
    })).isRequired,
    title: PropTypes.string,
    titleClassName: PropTypes.string,
};

Quickview.defaultProps = {
    layoutClassName: '',
    className: '',
    subtitle: '',
    title: '',
    titleClassName: '',
};

export {
    Metric,
};
export default Quickview;
